import { MutationTree } from 'vuex';
import { EUpdateGoogleDocsMutation } from '@/dealroom/google-docs/store/update-google-docs.constants';
import { IUpdateGoogleDocsState } from '@/dealroom/google-docs/store/update-google-docs.types';
import { IDocumentPage } from '@/types/document-page';

export const mutations: MutationTree<IUpdateGoogleDocsState> = {
  [EUpdateGoogleDocsMutation.SetPageCount](state: IUpdateGoogleDocsState, pageCount: number) {
    state.pageCount = pageCount;
  },
  [EUpdateGoogleDocsMutation.SetPages](state: IUpdateGoogleDocsState, pages: IDocumentPage[]) {
    state.importedPages = pages;
  },
  [EUpdateGoogleDocsMutation.SetError](state: IUpdateGoogleDocsState, error: string) {
    state.error = error;
  },
  [EUpdateGoogleDocsMutation.SetState](
    state: IUpdateGoogleDocsState,
    newState: IUpdateGoogleDocsState
  ) {
    state.importedPages = newState.importedPages;
    state.pageCount = newState.pageCount;
    state.error = newState.error;
  },
};
